const mediaQueries = {
    phone: '@media only screen and (max-width: 750px)',
}

module.exports = mediaQueries


// WEBPACK FOOTER //
// ./src/utils/breakpoints.js